export class Vector2 {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
    }
    length() {
      return Math.sqrt(this.sqrLength());
    }
    sqrLength() {
      return this.x * this.x + this.y * this.y;
    }
    add(_vec) {
      this.x += _vec.x;
      this.y += _vec.y;
    }
    sub(_vec) {
      this.x -= _vec.x;
      this.y -= _vec.y;
    }
    div(_f) {
      this.x /= _f;
      this.y /= _f;
    }
    mul(_f) {
      this.x *= _f;
      this.y *= _f;
    }
    dot(_vec) {
        return this.x*_vec.x + this.y*_vec.y;
    }
    normalize() {
      var sqrLen = this.sqrLength();
      if (sqrLen != 0) {
        var factor = 1.0 / Math.sqrt(sqrLen);
        this.x *= factor;
        this.y *= factor;
      }
    }
    getNormalized() {
      var sqrLen = this.sqrLength();
      if (sqrLen != 0) {
        var factor = 1.0 / Math.sqrt(sqrLen);
        return new Vector2(this.x * factor, this.y * factor);
      }
      return new Vector2(0, 0);
    }
}

export function mod(a, b) {
    return (a % b + b) %b;
}



// WEBPACK FOOTER //
// ./src/utils/MathUtils.js